import React from 'react';

import {
	BylineConnectionsPlaceholderVisual,
	type BylineConnectionsPlaceholderVisualProps,
} from '../BylineConnectionsPlaceholderVisual.tsx';

export type BylineConnectionsPlaceholderProps = Pick<
	BylineConnectionsPlaceholderVisualProps,
	'isOpen' | 'onOpenChange' | 'onOpenObserved'
> & {
	/**
	 * Tiles to paint: the count `useBylineTileReservation` captured on the page's first render. Zero
	 * paints nothing, which is the case for a page the server hid and after a client navigation.
	 */
	iconCount: number;
};

/**
 * The byline's loading footprint. It paints exactly the tiles the server reserved, so the row keeps
 * one width from server paint through hydration to the loaded stack. It never counts on its own:
 * the samples' cache entries keep filling after paint, and a fresh count would grow. CCINT-9543
 */
export const BylineConnectionsPlaceholder = ({
	iconCount,
	isOpen,
	onOpenChange,
	onOpenObserved,
}: BylineConnectionsPlaceholderProps): React.JSX.Element | null => {
	if (iconCount === 0) {
		return null;
	}

	return (
		<BylineConnectionsPlaceholderVisual
			iconCount={iconCount}
			isOpen={isOpen}
			onOpenChange={onOpenChange}
			onOpenObserved={onOpenObserved}
		/>
	);
};
